import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import BonRetourClient from '@/features/bon-retour-client'

export const Route = createFileRoute('/_authenticated/bon-retour-client/')({
  component: BonRetourClient,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Bon Retour Client`,
      },
    ],
  }),
})
